import React from 'react';
import { Mutation } from "react-apollo";
import { DELETE,GET_BY_PUBLISHER_ID } from "../../../../queries/settings";
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

function filteredData(s, l, ls){
  s.data.forEach(d => {
    const id = ls[d.dataIndex].id;
      l = l.filter(e => e.id !== id)
    })
  return l;
}

class Delete extends React.Component {
  render(){
    const { selectedRows, settingsData } = this.props;
    return (
      <Mutation
        mutation={DELETE}
        update={(store, { data: { deleteSetting } }) => {
        if(store.data.data.ROOT_QUERY){
          const { settingByPublisherId } = store.readQuery({ query: GET_BY_PUBLISHER_ID, variables:{ publisherId : this.props.publisherId }});
          store.writeQuery({
            query: GET_BY_PUBLISHER_ID,
            variables: { publisherId : this.props.publisherId },
            data: { settingByPublisherId: filteredData(selectedRows,settingByPublisherId,settingsData) }
          }); 
        }
        }}
        >
        {deleteSetting => (
          <div>
            <IconButton aria-label="delete" onClick = {
              e => {
                e.preventDefault();
                selectedRows.data.forEach(d => {
                  const id = settingsData[d.dataIndex].id;
                  deleteSetting({ variables: {id: id }})  
                });
              }
            }>
              <DeleteIcon />
            </IconButton>
          </div>
        )}
      </Mutation>
    );
  }
};

export default Delete;